<template>
  <div class="setting">
    <slot :active="active"></slot>
  </div>
</template>

<script>
export default {
  name: 'ICSetting',
  data () {
    return {
      active: undefined
    }
  },
  mounted () {
    this.$EventBus.$on('setActive', active => {
      this.active = active
    })
  },
  beforeDestroy () {
    this.$EventBus.$off('setActive')
  }
}
</script>

<style>
.setting {
  width: 300px;
  height: 100%;
  background-color: white;
  border: 1px solid #e8e8e8;

  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
}
</style>
